.root {
  height: 22px;
  padding-left: var(--spacingSm);
  padding-right: var(--spacingSm);
  border-radius: var(--radiusSm);
  cursor: pointer;

  & > label {
    cursor: pointer;
  }
}
